<template>
  <div class="autocomplete">
    <multiselect
      v-model="model.value"
      :select-label="null"
      :custom-label="optionLabelMapper"
      :placeholder="placeholder"
      searchable
      hide-selected
      v-bind="$attrs"
      @input="handleSelectOption"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'Autocomplete',
  components: {
    Multiselect
  },
  props: {
    value: {
      type: undefined
    },
    optionLabelMapper: {
      type: Function,
      default: (option) => option.label
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      model: {
        value: this.value
      }
    }
  },
  watch: {
    value: {
      handler(value) {
        this.model.value = value
      },
      immediate: true
    }
  },
  methods: {
    handleSelectOption(option) {
      this.$emit('input', option)
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'vue-multiselect/dist/vue-multiselect.min';

@use '@/../static/stylesheets/variables' as *;

.autocomplete {
  display: flex;
  flex: 1;

  ::v-deep(.multiselect) {
    font-size: 14px;
  }

  ::v-deep(.multiselect__input) {
    font-size: 14px;
  }

  ::v-deep(.multiselect__select) {
    background-color: transparent;
  }

  ::v-deep(.multiselect__select::before) {
    border-color: #7F1A54 transparent transparent;
  }

  ::v-deep(.multiselect__option--highlight) {
    background-color: $brand-primary;
  }

  ::v-deep(.multiselect__option--highlight::after) {
    background-color: rgba(0, 0, 0, 0.2);
    padding-left: 12px;
  }
}
</style>
